import { makeStyles, shorthands } from '@fluentui/react-components';
import { SOC_COLORS } from 'themes';

export const useLiveIndicatorStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('8px'),
    fontFamily: "'Share Tech Mono', monospace",
  },
  indicator: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('6px'),
    ...shorthands.padding('4px', '10px'),
    ...shorthands.borderRadius('4px'),
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    ...shorthands.border('1px', 'solid', 'rgba(255, 255, 255, 0.1)'),
  },
  pulse: {
    width: '10px',
    height: '10px',
    ...shorthands.borderRadius('50%'),
    position: 'relative',
  },
  pulseGreen: {
    backgroundColor: SOC_COLORS.green,
    boxShadow: `0 0 8px ${SOC_COLORS.green}`,
    animationName: {
      '0%': { opacity: 1, transform: 'scale(1)' },
      '50%': { opacity: 0.7, transform: 'scale(1.1)' },
      '100%': { opacity: 1, transform: 'scale(1)' },
    },
    animationDuration: '2s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
  },
  pulseYellow: {
    backgroundColor: SOC_COLORS.yellow,
    boxShadow: `0 0 8px ${SOC_COLORS.yellow}`,
    animationName: {
      '0%': { opacity: 1 },
      '50%': { opacity: 0.5 },
      '100%': { opacity: 1 },
    },
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
  },
  pulseRed: {
    backgroundColor: SOC_COLORS.red,
    boxShadow: `0 0 8px ${SOC_COLORS.red}`,
  },
  statusText: {
    fontSize: '11px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  statusTextGreen: {
    color: SOC_COLORS.green,
  },
  statusTextYellow: {
    color: SOC_COLORS.yellow,
  },
  statusTextRed: {
    color: SOC_COLORS.red,
  },
  lastSeen: {
    fontSize: '10px',
    color: SOC_COLORS.textDim,
    letterSpacing: '0.5px',
  },
});
